import React from 'react';

// Aísla fallos de render: si un hijo tira una excepción, se muestra el
// `fallback` en su lugar en vez de romper toda la página. En la agenda se
// envuelve cada fila, así un bug en una fila no tumba la planilla entera.
//
// resetKey: cuando cambia, el boundary se recupera (permite volver a intentar
// al recargar los datos, sin recargar la página).
type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  resetKey?: unknown;
  label?: string;
};

type State = { failed: boolean };

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error(`[ErrorBoundary${this.props.label ? ` ${this.props.label}` : ''}]`, error, info?.componentStack);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (this.state.failed) return this.props.fallback ?? null;
    return this.props.children;
  }
}
